module.exports = __webpack_public_path__ + "media/images/header-1acbe8aa97375e00efa92ecb85f47c31.png";